import axios from "axios";
import ApiClient from "./apiClient";

interface UpdateProfileData {
  name: string;
  password?: string;
}

interface ChangePasswordData {
  password: string;
  name: string;
}

const partnerAuthService = {
  signIn: (data: any) => ApiClient.post('/auth/staff/login', data),
  getMe: (data:any) => ApiClient.get('/auth/staff/me', data),

  // Update profile for staff/admin (name and/or password)
  // Backend uses the same endpoint for both name and password updates
  updateProfile: (data: UpdateProfileData) => {
    // Only include password in payload if it's provided and not empty
    const payload: any = { name: data.name };
    if (data.password && data.password.trim() !== '') {
      payload.password = data.password;
    }
    return ApiClient.patch('/auth/staff', payload);
  },

  // Change password for staff/admin
  // Must include name as backend requires it
  changePasswordSettings: (data: ChangePasswordData) => ApiClient.patch('/auth/staff', data),
}

export default partnerAuthService 
